import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useShallowAppSelector } from 'store/hooks';
import MasterProfileContainer from 'containers/user/MasterProfileContainer';
import EmployeeProfileContainer from 'containers/user/EmployeeProfileContainer';
import UserHistoryContainer from 'containers/user/UserHistoryContainer';
import SoftwareSettingContainer from 'containers/user/SoftwareSettingContainer';
import T from 'components/common/text/T';
import { IUserProfile } from 'lib/types/userTypes';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import MuiWrapper from 'components/common/input/MuiWrapper';
import {
  isMasterLevelUserSelector,
  isManagerLevelUserSelector,
  isNormalLevelUserSelector,
} from 'store/modules/user';
import cx from 'classnames';
import { BaseActions, UtilActions } from 'store/actionCreators';
import PageTitle, { PageSubTitle } from 'components/base/title/PageTitle';
import { useTranslation } from 'react-i18next';
import { useDidUpdateEffect } from 'lib/utils';

function UserContainer() {
  const {
    language,
    user,
    isMasterLevelUser,
    isManagerLevelUser,
    isNormalLevelUser,
    supportLanguageList: { list: languageList },
    supportLanguageListSuccess,
  }: {
    language: string;
    user: IUserProfile;
    isMasterLevelUser: boolean;
    isManagerLevelUser: boolean;
    isNormalLevelUser: boolean;
    supportLanguageList: { list: any };
    supportLanguageListSuccess: boolean;
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    user: state.user.user || {},
    isMasterLevelUser: isMasterLevelUserSelector(state),
    isManagerLevelUser: isManagerLevelUserSelector(state),
    isNormalLevelUser: isNormalLevelUserSelector(state),
    supportLanguageList: state.util.supportLanguageList.data || {},
    supportLanguageListSuccess: state.util.supportLanguageList.success,
  }));

  const [lang, setLang] = useState<string>(language);
  const handleChangeLanguage = (e: any) => {
    setLang(e.target.value);
    BaseActions.change_language(e.target.value);
  };
  const { t } = useTranslation();
  const authorityNameList = {};

  useEffect(() => {
    UtilActions.fetch_support_language_list_request();
  }, []);

  return (
    <StyledUser data-component-name="User">
      <PageTitle title={t('MY_PAGE_TITLE')} />
      <div className="user__title_box">
        <PageSubTitle title={t('GLOBAL_INFORMATION')} />
        {/* <h1 className="user__title">
          <T>GLOBAL_INFORMATION</T>
        </h1> */}
        <div className="user__language_box">
          <div className="user__language_label">
            <T>GLOBAL_LANGUAGE</T>
          </div>
          <div className="user__language">
            <MuiWrapper className="user__language_select_wrapper sm">
              <FormControl fullWidth variant="outlined">
                {/* <StyledGlobalCurrencySelect /> */}
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },

                    getContentAnchorEl: null,
                  }}
                  name="language"
                  value={lang}
                  onChange={e => {
                    handleChangeLanguage(e);
                  }}
                >
                  {languageList?.map(
                    (item: any, index: number) => {
                      return (
                        <MenuItem value={item.language.toLowerCase()} key={index}>
                          {item.languageAlias}
                        </MenuItem>
                      );
                    },
                    [lang],
                  )}
                </Select>
              </FormControl>
            </MuiWrapper>
          </div>
        </div>
      </div>
      {useMemo(
        () => (
          <>
            {/* {(user.authorityName === 'Master' || user.authorityName === 'Manager') && ( */}
            {!!isMasterLevelUser ? (
              <>
                <MasterProfileContainer />
                <SoftwareSettingContainer />
                {/* <UserKPIContainer /> */}
                {/* <UserProfileContainer /> */}
                {/* <UserHistoryContainer /> */}
              </>
            ) : (
              <>
                <EmployeeProfileContainer />
                <SoftwareSettingContainer />
              </>
            )}

            {/* {user.authorityName === 'Employee' && (
              <>
                <EmployeeProfileContainer />
              </>
            )} */}
          </>
        ),
        [user.authorityName],
      )}
      <div className="User__footer"></div>
    </StyledUser>
  );
}
const StyledUser = styled.section<{}>`
  /* display: flex;
  flex-direction: column;
  row-gap: 40px; */
  /* margin-top: 30px; */
  .user__title_box {
    display: flex;
    justify-content: space-between;
    .user__title {
      font-size: 26px;
      font-weight: 500;
    }
    .user__language_box {
      display: flex;
      column-gap: 30px;
      align-items: center;
      .user__language_label {
        font-size: 14px;
        font-weight: 500;
      }
      .user__language {
        width: 200px;
      }
    }
  }
  .User__footer {
    width: 100%;
    height: 100px;
  }
`;
export default React.memo(UserContainer);
